const CONFIRM_RESERVATION_SUCCESS_TEXT = "Votre réservation a bien été envoyée au restaurant! \nCopiez le lien de cette page pour consulter le statut de votre réservation.";
export const CONFIRM_RESERVATION_SUCCESS = CONFIRM_RESERVATION_SUCCESS_TEXT;

const CONFIRM_ORDER_SUCCESS_TEXT = "Votre commande a bien été envoyée au restaurant!";
export const CONFIRM_ORDER_SUCCESS = CONFIRM_ORDER_SUCCESS_TEXT;

const CANCEL_RESERVATION_SUCCESS_TEXT = "Votre réservation a bien été annulée!";
export const CANCEL_RESERVATION_SUCCESS = CANCEL_RESERVATION_SUCCESS_TEXT;

const CONTACT_RESTAURANT_SUCCESS_TEXT = "Votre demande a bien été envoyée au restaurant!";
export const CONTACT_RESTAURANT_SUCCESS = CONTACT_RESTAURANT_SUCCESS_TEXT;

const CANCEL_ORDER_SUCCESS_TEXT = "Votre commande a bien été annulée!";
export const CANCEL_ORDER_SUCCESS = CANCEL_ORDER_SUCCESS_TEXT;

export const ANSWER_SURVEY_SUCCESS = "Votre réponse a bien été envoyée !";

export const ANSWER_BARESTHO_SURVEY_SUCCESS = "Votre réponse a bien été envoyée !";


// WEBPACK FOOTER //
// ./src/successes.js